/** «Аналитика»: отчёты-файлы `docs/analytics` (`reels/web/api_analytics.py`), только чтение. */
import { apiFetch } from "@/lib/api";

export type ReportRef = { slug: string; title: string; date: string };
export type Report = ReportRef & { markdown: string };

export const analyticsKeys = {
  list: ["analytics", "list"] as const,
  one: (slug: string) => ["analytics", "one", slug] as const,
};

export const loadReports = () => apiFetch<{ reports: ReportRef[] }>("/api/analytics");
export const loadReport = (slug: string) => apiFetch<Report>(`/api/analytics/${encodeURIComponent(slug)}`);
export const reportPath = (slug: string) => `/analytics/${slug}`;
